import { render, staticRenderFns } from "./AdvertiserList.vue?vue&type=template&id=4afb563e"
import script from "./AdvertiserList.vue?vue&type=script&lang=js"
export * from "./AdvertiserList.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserList.vue?vue&type=style&index=0&id=4afb563e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports